/* eslint-disable */
import { AppBar, Box, Dialog, IconButton, Toolbar, Typography, Slide, Button, Grid, DialogTitle, FormControlLabel, Checkbox, TextField, InputBase } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as BigArrowIcon } from "../Assets/svg/bigArrowIcon.svg";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as PhoneIcon } from "../Assets/svg/PhoneIcon.svg";
import { ReactComponent as GreenArrow } from "../Assets/svg/greenArrow.svg";
import { ReactComponent as BooksIcon } from "../Assets/svg/BooksIcon.svg";
import ButtonNavigation from './ButtonNavigation';
import { ReactComponent as ThreeDotsIcon } from "../Assets/svg/ThreeDotsIcon.svg";
import { ReactComponent as WhiteLocationIcon } from "../Assets/svg/WhiteLocationIcon.svg";
import { ReactComponent as PersonCircleIcon } from "../Assets/svg/PersonCircleIcon.svg";
import { ReactComponent as GrayLocation } from "../Assets/svg/GrayLocation.svg";
import { ReactComponent as GreenCheckIcon } from "../Assets/svg/GreenCheckIcon.svg";
import { ReactComponent as FloorIcon } from "../Assets/svg/FloorIcon.svg";
import { ReactComponent as MobileIcon } from "../Assets/svg/MobileIcon.svg";
import { ReactComponent as MailIcon } from "../Assets/svg/MailIcon.svg";
import { ReactComponent as FloorNumIcon } from "../Assets/svg/FloorNumIcon.svg";
import { ReactComponent as RoomIcon } from "../Assets/svg/RoomIcon.svg";
import { ReactComponent as ZirbanaIcon } from "../Assets/svg/ZirbanaIcon.svg";
import { ReactComponent as UsageTypeIcon } from "../Assets/svg/UsageTypeIcon.svg";
import { ReactComponent as MasahatIcon } from "../Assets/svg/MasahatIcon.svg";
import { ReactComponent as GreenDotIcon } from "../Assets/svg/GreenDotIcon.svg";
import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as PlusIcon } from "../Assets/svg/PlusIcon.svg";
import { ReactComponent as CalendarIcon } from "../Assets/svg/CalendarIcon.svg";
import { ReactComponent as LabelsIcon } from "../Assets/svg/LabelsIcon.svg";
import { ReactComponent as HouseIcon } from "../Assets/svg/HouseIcon.svg";
import { ReactComponent as ShareIcon } from "../Assets/svg/ShareIcon.svg";
import { ReactComponent as SendIcon } from "../Assets/svg/SendIcon.svg";
import { ReactComponent as PenIcon } from "../Assets/svg/PenIcon.svg";
import { ReactComponent as BackUpIcon } from "../Assets/svg/BackUpIcon.svg";
import { ReactComponent as DelIcon } from "../Assets/svg/DelIcon.svg";
import { ReactComponent as RoundArrowsIcon } from "../Assets/svg/RoundArrowsIcon.svg";
import { ReactComponent as SettingDarkGray } from "../Assets/svg/SettingDarkGray.svg";
import { ReactComponent as PlusGreenIcon } from "../Assets/svg/PlusGreenIcon.svg";
import { ReactComponent as CheckIcon } from "../Assets/svg/CheckIcon.svg";
import Snackbar from '@mui/material/Snackbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useParams } from "react-router-dom";
// Import Swiper styles
import 'swiper/css';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../api/axiosInstance';
import moment from "moment-jalaali"
import { useUserStore } from '../store/user';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
import { useSnackbar } from 'notistack';
import { TileLayer, Marker, Popup, MapContainer } from 'react-leaflet'
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import { useSearchPropStore } from '../store/searchProperty';
import PropertyContactModal from "./PropertyContactModal";
import { CheckPermissions } from "./CheckPermissions";
import ModalComponent from "./ModalComponent";
import { newShade, lightOrDark, getUserToken } from "./PublicFunctions";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from './persian-mobile-datepicker-config'
import Cookies from 'js-cookie'
import ShareModalCompo from "./ShareModal";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

function LocationMarker(props) {



    return props.position === null ? "" : (
        <Marker position={props.position}>
            <Popup> </Popup>
        </Marker>
    )
}

function SetLabelsModal(props) {

    const navigate = useNavigate();


    const { enqueueSnackbar } = useSnackbar();









    const userInfo = useUserStore((state) => state.userInfo)
    const setUserInfo = useUserStore((state) => state.setUserInfo)



    const [openBackdrop, setOpenBackdrop] = React.useState(false);




    const [commissionUsers, setCommissionUsers] = useState([
        { AgencyId: "", Price: "", Name: "" }
    ]);
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [RentReminderDate, setRentReminderDate] = useState("")
    const [indexUserSelected, setIndexUserSelected] = useState(null)
    const [commissionUsersLoading, setCommissionUsersLoading] = useState(false)
    const [archiveSelectedId, setArchiveSelectedId] = useState(false)

    const [archiveModal, setArchiveModal] = useState(false);

    const [tmpIsBought, setTmpIsBought] = useState(false);

    const [openMoreOptionsModal, setOpenMoreOptionsModal] = useState(false)
    const [openLabelsModal, setOpenLabelsModal] = useState(false)

    const propertySelected = useSearchPropStore((state) => state.propertySelected)
    const setPropertySelected = useSearchPropStore((state) => state.setPropertySelected)

    const [uploadImagesLoading, setUploadImagesLoading] = useState(false);



    const [labelsLoading, setLabelsLoading] = useState(false);

    const [labelIndexForUser, setLabelIndexForUser] = useState("")


    const [labelsChecked, setLabelsChecked] = useState({})


    const dataFetchedRef = useRef(false);

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

      

    }, [])

    const { labelsDetails } = props


    useEffect(() => {
        console.log("🚀 ~ SetLabelsModal ~ labelsDetails:", labelsDetails)

        if (labelsDetails && labelsDetails.length) {
            const tmpLabelsChecked = {}
            labelsDetails.forEach((item) => {
                tmpLabelsChecked[item.LabelId] = {}
                tmpLabelsChecked[item.LabelId][`showPicker${item.LabelId}`] = false
                tmpLabelsChecked[item.LabelId]["id"] = item.LabelId
                tmpLabelsChecked[item.LabelId]["AgencyName"] = item.AssignedUserFullName
                tmpLabelsChecked[item.LabelId]["AssignedUser"] = item.AssignedUser
                tmpLabelsChecked[item.LabelId]["DailyReminder"] = +item.DailyReminder
                tmpLabelsChecked[item.LabelId]["RemindDate"] = +item.RemindDate
                tmpLabelsChecked[item.LabelId]["RepeatDays"] = item.RepeatDays
            });
            setLabelsChecked(tmpLabelsChecked)

        }
    }, [labelsDetails])



    const handleSetUserLabel = (user) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("labelIndexForUser", labelIndexForUser)
        labelsCheckedTmp[labelIndexForUser].AssignedUser = user.id
        labelsCheckedTmp[labelIndexForUser].AgencyName = user.username
        setLabelsChecked(labelsCheckedTmp)

        handleOpenUsersModalClose()
    }

    const handleNavigateToSettingLabels = () => {
        navigate("/settings", { state: { showLabel: true } });

    }

    const closePickerHandle = (index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index][`showPicker${index}`] = false
        setLabelsChecked(labelsCheckedTmp)
    }

    const showPickerHandle = (index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index][`showPicker${index}`] = true
        setLabelsChecked(labelsCheckedTmp)
    }

    const handleSetRepeatDays = (e, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index]['RepeatDays'] = e.target.value
        console.log("e.target.value", e.target.value)
        setLabelsChecked(labelsCheckedTmp)
    }

    const handleSaveLabels = async () => {
        handleToggleBackdrop()
        console.log("labelsChecked", labelsChecked)
        let labels = {
            Labels: [],
            EntityId: props.Id,
            EntityType: 1
        }
        for (const label in labelsChecked) {
            if (!label?.isOld) {
                labels.Labels.push({
                    "LabelId": parseInt(labelsChecked[label].id),
                    "AssignedUser": labelsChecked[label].AssignedUser,
                    "RemindDate": labelsChecked[label].RemindDate,
                    "EntityId": props.Id,
                    "EntityType": 1,
                    "DailyReminder": labelsChecked[label].DailyReminder,
                    "RepeatDays": labelsChecked[label].RepeatDays,
                })
            }

        }

        try {
            const response = await http({
                url: `/webapp/entities/save_labels`,
                method: "POST",
                data: labels,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (response.data.result.result) {
                const variant = 'success'
                enqueueSnackbar('نشان گذاری های شما با موفقیت ثبت شد.', { variant });
                console.log("🚀 ~ handleSaveLabels ~ props.Id:", props.Id)

                navigate(`/property/${props.Id}`)
                props.handleLabelsModalClose()
                if (props?.handleMoreOptionsModalClose)
                    props.handleMoreOptionsModalClose()

                if (props?.handleGetLabels)
                    props.handleGetLabels()
            }

        } catch (e) {
            console.error(e);
        }

        handleCloseBackdrop()

    }

    const LabelReminderDateHandle = (selectedDate, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("index", index)
        labelsCheckedTmp[index].RemindDate = +selectedDate.date
        setLabelsChecked(labelsCheckedTmp)

    }

    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }



    const handleAddEntityLabel = (id) => {
        console.log("🚀 ~ handleAddEntityLabel ~ handleAddEntityLabel:")
        document.getElementById(`label-${id}`).classList.toggle("label-selected")

        let labelsCheckedTmp = { ...labelsChecked }

        if (id in labelsCheckedTmp)
            delete labelsCheckedTmp[id]
        else {
            labelsCheckedTmp[id] = { RemindDate: +(new Date()) }
            labelsCheckedTmp[id][`showPicker${id}`] = false
            labelsCheckedTmp[id].id = id
        }

        setLabelsChecked(labelsCheckedTmp)
    }

    useEffect(() => {
        console.log("labelsChecked", labelsChecked)

    }, [labelsChecked])







    //user modal
    const handleClickOpenUsersModal = (index = null, label = null) => {
        if (index || index == 0) {
            console.log("index", index)
            setIndexUserSelected(index)

        }
        if (label || label == 0) {
            setLabelIndexForUser(label)
            console.log("label", label)
        }
        getUsers(true)
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };
    // const handleClickOpenUsersModal = (index) => {
    //     console.log("index",index)
    //     setIndexUserSelected(index)
    //     getUsers(true)
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
    //             console.log("Users Use")
    //             document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
    //             return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
    //         }
    //     }, 500)
    //     setOpenUsersModal(true);
    // };
    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };

    const [Users, setUsers] = React.useState([]);
    const [UserOffset, setUserOffset] = React.useState(1);
    const [HasMoreUsers, setHasMoreUsers] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [inPlusingUser, setinPlusingUser] = React.useState(true);
    const [propKey, setPropKey] = React.useState(0);


    const getUsers = (resetState = false) => {
        if (resetState) {
            setUsers([])
            console.log("reset", Users)
            setPropKey(propKey => propKey++)
            setUserOffset(0);
            setHasMoreUsers(true)
        }

        setUsersLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/users/get-my-users",
                method: "GET",
                // data: {
                //     "Limit": 10,
                //     "Offset": UserOffset
                // },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("users", res.data.result.Users);

                const tmpProp = [...Users]
                if (res.data.result.Users.length > 0) {
                    if (!resetState) {
                        res.data.result.Users.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setUsers(tmpProp)

                        setPropKey(propKey => propKey++)
                    }
                    else
                        setUsers(res.data.result.Users)


                    setPropKey(propKey => propKey++)

                } else {
                    console.log("End")
                    setHasMoreUsers(false)
                    if (resetState) setUsers([])

                }

                console.log("users ff", Users)
                setUsersLoading(false)
                setTimeout(function () { setinPlusingUser(true) }, 1000)
            });

        } catch (e) {
            console.error(e);
            setUsersLoading(false)

        }


    }


    const onUsersScroll = () => {
        if (document.getElementById("users-content")) {

            const scrollTop = document.getElementById("users-content").scrollTop
            const scrollHeight = document.getElementById("users-content").scrollHeight
            const clientHeight = document.getElementById("users-content").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && inPlusingUser) {
                setUserOffset(UserOffset => UserOffset + 1);
                // setSearchData({"name":"Offset","value":UserOffset})
                console.log("UserOffset", UserOffset)
                setinPlusingUser(false)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)

        // setPropertySelected(id)


    }, [Users])

    console.log("propertySelected", propertySelected)

    useEffect(() => {
        console.log("offset use")

        if (HasMoreUsers && Users.length) {
            getUsers()
        }
    }, [UserOffset])




    // const handleSetUserArchive = (user) => {
    //     let tmp = [...commissionUsers]
    //     console.log("indexUserSelected",indexUserSelected)
    //     tmp[indexUserSelected].Name = user.FullName
    //     tmp[indexUserSelected].AgencyId = user.Id
    //     tmp[indexUserSelected].Id = user.Id
    //     console.log("users", commissionUsers)
    //     handleOpenUsersModalClose()
    // }
    const handleSetUserArchive = (user) => {
        let tmp = [...commissionUsers]
        tmp[indexUserSelected].Name = user.username
        tmp[indexUserSelected].AgencyId = user.id
        console.log("users", commissionUsers)
        handleOpenUsersModalClose()
    }



    ///////////////////////////////

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };



    const handleLabelDailyReminder = (e, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("index", index)
        if (e.target.checked)
            labelsCheckedTmp[index].DailyReminder = 1
        else
            labelsCheckedTmp[index].DailyReminder = 0

        setLabelsChecked(labelsCheckedTmp)
    }



    useEffect(() => {


        if (props?.openLabelsModal) {
            console.log("🚀 ~ useEffect ~ props?.openLabelsModal:", props?.openLabelsModal)

        }
    }, [props?.openLabelsModal])

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {openUsersModal && <Dialog className="dialog-box"
                fullScreen
                open={openUsersModal}
                onClose={handleOpenUsersModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            کاربران
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenUsersModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                    <Box >
                        <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                            <Button className="userItem" sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 2 }} onClick={() => props?.isLabelOn ? handleSetUserLabel(userInfo) : handleSetUserArchive(userInfo)} >
                                <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>
                                    <Box sx={{ bgcolor: "#fff", borderRadius: "50%", width: "40px", height: "40px" }}>
                                    </Box>
                                    <Typography component="span">خودم</Typography>
                                </Box>
                                {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                            </Button>
                            {
                                Users && Users.length > 0 ?
                                    Users.map((item, index) => (

                                        <Button className="userItem" sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 2 }} onClick={() => props?.isLabelOn ? handleSetUserLabel(item) : handleSetUserArchive(item)} key={index}>
                                            <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>
                                                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", width: "40px", height: "40px" }}>
                                                </Box>
                                                <Typography component="span">{item.username}</Typography>
                                            </Box>
                                            {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                                        </Button>

                                    ))
                                    : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                            }

                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button>
            </Dialog>}

            {props.openLabelsModal && <ModalComponent showModalState={props.openLabelsModal}
                handleModalClose={props.handleLabelsModalClose}
                modalTitle="نشان گذاری ها"
                modalSubmitBtn={handleSaveLabels}
                modalTitleSubmitBtn="ذخیره"
                hasSpecificParent={true}
                headerRightBtnFunction={handleNavigateToSettingLabels}
                modalHeaderRightBtn={true}
                headerRightBtnClass="rounded-50"
                headerRightBtnTitle={<SettingDarkGray />}
            // headerRightBtnStyle={{ bgcolor: '#8F8F8F!important', fontSize: '11px', color: '#fff' }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", p: 2 }}>

                    {
                        props.labels && props.labels.length > 0 ?
                            props.labels.map((item, index) => (
                                <Box sx={{ display: "flex", alignItems: "center" }} key={index}>
                                    <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                                    <Box sx={{ width: "100%" }} id={`label-${item.Id}`} className={`labels-entity ${item.Id in labelsChecked ? 'label-selected' : ''}`}>
                                        <Box className='border-0 labels-item' sx={{ p: 1, bgcolor: newShade(item.ColorCode, 40) }}>
                                            <Box className="circle-color" sx={{ bgcolor: item.ColorCode }}></Box>
                                            <Box sx={{ flex: "1", textAlign: "center", color: lightOrDark(item.ColorCode) == "light" ? "#5a5a5a!important" : "#fff!important" }}>
                                                {item.Text}
                                            </Box>
                                        </Box>
                                        {
                                            item.Id in labelsChecked ?
                                                <Box>
                                                    <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal(null, item.Id)} sx={{ width: 'auto', mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', bgcolor: "#fff" }}>
                                                        <span> {labelsChecked[item.Id] && labelsChecked[item.Id].AgencyName ? `توسط ${labelsChecked[item.Id]?.AgencyName}` : ""}</span>
                                                        <ArrowRightIcon className='rotate-90' />
                                                    </Box>
                                                    <Box sx={{ display: "flex", gap: "5px", alignItems: "center", mt: 1 }}>
                                                        در تاریخ
                                                        <Box className="labelDate">
                                                            <InputBase value={formatJalali(labelsChecked[item.Id].RemindDate)} className='f-14' onClick={() => showPickerHandle(item.Id)} />
                                                            <Picker
                                                                isOpen={labelsChecked[item.Id][`showPicker${item.Id}`]}
                                                                config={config}
                                                                value={labelsChecked[item.Id] && labelsChecked[item.Id].RemindDate ? new Date(labelsChecked[item.Id].RemindDate) : new Date()}
                                                                initialValue={labelsChecked[item.Id] && labelsChecked[item.Id].RemindDate ? new Date(labelsChecked[item.Id].RemindDate) : new Date()}
                                                                minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                                                maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                                                onSubmit={(date) => LabelReminderDateHandle(date, item.Id)}
                                                                // onChange={(date) => LabelReminderDateHandle(date, item.Id)}
                                                                onClose={() => closePickerHandle(item.Id)}
                                                                highlightWeekends
                                                            />
                                                            <CalendarIcon width="30px" />

                                                        </Box>
                                                        یادآوری شود.
                                                    </Box>
                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                        <Checkbox id={`daily-remind${index}`} sx={{ mr: "-10px" }} className='green-check' checked={labelsChecked[item.Id]["DailyReminder"]} onChange={e => handleLabelDailyReminder(e, item.Id)} />
                                                        <label for={`daily-remind${index}`} style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                                            به صورت روزانه تکرار شود تا
                                                            <Box className="labelDate" sx={{ width: "35px!important" }}>
                                                                <InputBase className='f-14' type="number" sx={{ textAlign: "center!important" }} value={labelsChecked[item.Id]["RepeatDays"]} onChange={e => handleSetRepeatDays(e, item.Id)} />
                                                            </Box>
                                                            روز
                                                        </label>
                                                    </Box>

                                                </Box>
                                                : ""
                                        }
                                    </Box>
                                    <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
                                        <Checkbox className='green-check f-16' onChange={e => handleAddEntityLabel(item.Id)} checked={item.Id in labelsChecked} />
                                    </Box>
                                </Box>
                            ))
                            : !labelsLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                    }
                    {
                        labelsLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                    }


                </Box>
            </ModalComponent>}
        </>
    );
}

export default SetLabelsModal;